import { render, staticRenderFns } from "./RelatorioRetornouOrigemListConcluidos.vue?vue&type=template&id=758b978c"
import script from "./RelatorioRetornouOrigemListConcluidos.vue?vue&type=script&lang=js"
export * from "./RelatorioRetornouOrigemListConcluidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports